module.exports = __webpack_public_path__ + "img/GU.c3db56a6.svg";